module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.1a20bf82.jpg";